import React from "react";
import PropTypes from "prop-types";
// ui
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// style
import { styled } from "@material-ui/styles";

const StyledListItem = styled(ListItem)(({ theme }) => ({
  "&.MuiListItem-root": {
    marginBottom: "0.5rem",
    // "& .MuiListItemSecondaryAction-root": {
    //   right: 0,
    // },
  },
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  "&.MuiListItemButton-root": {
    borderRadius: "8px",
    color: "white",
    "&:hover, &:focus": {
      backgroundColor: "rgba(59, 191, 240, 0.1)",
      color: "#3BBFF0",
    },

    "&.Mui-selected": {
      backgroundColor: "rgba(59, 191, 240, 0.1)",
      color: "#3BBFF0",
    },
  },
}));

//
const ListItemSidebar = ({
  listIcon,
  textPrimary,
  textSecondary,
  listItemProps,
  listItemButtonProps,
  listItemTextProps,
  sx,
}) => {
  const getSx = () => {
    if (sx) return sx;
    return {};
  };

  return (
    <StyledListItem disablePadding {...listItemProps} sx={getSx()}>
      <StyledListItemButton {...listItemButtonProps}>
        {listIcon && <ListItemIcon>{listIcon}</ListItemIcon>}
        <ListItemText
          primary={textPrimary}
          secondary={textSecondary}
          {...listItemTextProps}
        />
      </StyledListItemButton>
    </StyledListItem>
  );
};

ListItemSidebar.propTypes = {
  listIcon: PropTypes.node,
  textPrimary: PropTypes.node,
  textSecondary: PropTypes.node,
  listItemProps: PropTypes.objectOf(PropTypes.any),
  listItemButtonProps: PropTypes.objectOf(PropTypes.any),
  listItemTextProps: PropTypes.objectOf(PropTypes.any),
  sx: PropTypes.objectOf(PropTypes.any),
};

ListItemSidebar.defaultProps = {
  listIcon: null,
  textPrimary: "",
  textSecondary: "",
  listItemProps: {},
  listItemButtonProps: {},
  listItemTextProps: {},
  sx: {},
};

export default ListItemSidebar;
